interface PickupAvailabilityComponent {
  init(): void;
  $refs?: {
    mainWrapper: HTMLElement;
    drawer: HTMLElement;
    errorTemplate: HTMLTemplateElement;
  };
  errorHtml: HTMLElement | null;
  focusElement: HTMLElement | null;
  variantId: string;
  rootUrl: string;
  productPageColorScheme: string;
  available: boolean;
  fetchAvailability(variantId: string): void;
  onClickRefreshList(): void;
  update(variant: {id: string; available: boolean}): void;
  renderError(): void;
  renderPreview(sectionInnerHTML: HTMLElement): void;
  handleBodyClick(evt: MouseEvent): void;
  hide(): void;
  show(focusElement: HTMLElement): void;
}

export default {
  name: 'pickupAvailability',
  component(): PickupAvailabilityComponent {
    return {
      errorHtml: null,
      focusElement: null,
      variantId: '',
      rootUrl: '',
      productPageColorScheme: '',
      available: false,

      init() {
        this.variantId = this.$el.dataset.variantId;
        this.rootUrl = this.$el.dataset.rootUrl;
        this.productPageColorScheme = this.$el.dataset.productPageColorScheme;
        this.available = this.$el.hasAttribute('available');

        if (!this.available) return;

        this.errorHtml = this.$refs.errorTemplate?.content.firstElementChild?.cloneNode(true) as HTMLElement;
        this.fetchAvailability(this.variantId);
      },

      fetchAvailability(variantId: string) {
        if (!variantId) return;

        let rootUrl = window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`;
        fetch(rootUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.$el.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      },

      onClickRefreshList() {
        this.fetchAvailability(this.variantId);
      },

      update(variant: {id: string; available: boolean}) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.$el.removeAttribute('available');
          this.$el.innerHTML = '';
        }
      },

      renderError() {
        this.$el.innerHTML = '';
        if (this.errorHtml) {
          this.$el.appendChild(this.errorHtml);
        }

        const button = this.$el.querySelector('button');
        if (button) {
          button.addEventListener('click', this.onClickRefreshList);
        }
      },

      renderPreview(sectionInnerHTML: HTMLElement) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();

        if (!sectionInnerHTML.querySelector('.pickup-availability-preview')) {
          this.$el.innerHTML = '';
          this.$el.removeAttribute('available');
          return;
        }

        this.$el.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-preview').outerHTML;
        this.$el.setAttribute('available', '');

        const drawerElement = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (drawerElement) {
          document.body.appendChild(drawerElement);
          const colorClassesToApply = this.productPageColorScheme.split(' ');
          colorClassesToApply.forEach((colorClass) => {
            drawerElement.classList.add(colorClass);
          });
        }

        const button = this.$el.querySelector('button');
        if (button) {
          button.addEventListener('click', (evt) => {
            const drawer = document.querySelector('pickup-availability-drawer') as HTMLElement;
            if (drawer) {
              this.show(evt.target as HTMLElement);
            }
          });
        }
      },

      handleBodyClick(evt: MouseEvent) {
        const target = evt.target as HTMLElement;
        if (
          target != this.$refs.drawer &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      },

      hide() {
        if (this.$refs.drawer) {
          this.$refs.drawer.removeAttribute('open');
          document.body.removeEventListener('click', this.handleBodyClick);
          document.body.classList.remove('overflow-hidden');
          // Note: removeTrapFocus implementation would need to be added
        }
      },

      show(focusElement: HTMLElement) {
        if (this.$refs.drawer) {
          this.focusElement = focusElement;
          this.$refs.drawer.setAttribute('open', '');
          document.body.addEventListener('click', this.handleBodyClick);
          document.body.classList.add('overflow-hidden');
          // Note: trapFocus implementation would need to be added
        }
      }
    };
  },
}
